// Author : Ayesha
//  Dated : 2025-06-08

import {
  Button,
  Checkbox,
  Collapse,
  FormControl,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import CustomTextFieldComp from "../../newTestPrep/newComponent/customTextFieldComp";
import MainCard from "../../components/Maincard";
import ApplyFilterButton from "../../newTestPrep/newComponent/NewButtonComp/ApplyFilterButton";
import ResetFilterButton from "../../newTestPrep/newComponent/NewButtonComp/ResetFilterButton";
import CustomAutocompleteComp from "../../newTestPrep/newComponent/AutocompleteComp";
import { useGetTokenOrLogout } from "../../utils/token";
import { useNavigate } from "react-router-dom";
import { fDateTime, useDateUtils } from "../../utils/formatTime";
import CustomSnackbar from "../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function TicketFilter({
  open,
  handleToggle,
  setLoading,
  setticketdata,
  originalTicketData,
}) {
  const today = new Date().toISOString().split("T")[0];
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const getTokenOrLogout = useGetTokenOrLogout();
  const navigate = useNavigate();
  const { todaysDate, oneMonthAgoDate } = useDateUtils();
  let userId = localStorage.getItem("userId");
  const [tickettype, setTicketType] = useState([]);
  const [createdBy, setCreatedBy] = useState([]);
  const [createdbylist, setCreatedbylist] = useState([]);
  const [dateFrom, setDateFrom] = useState(oneMonthAgoDate);
  const [dateTo, setDateTo] = useState(todaysDate);
  const [urgency, setUrgency] = useState([]);
  const [status, setStatus] = useState([]);
  // const handleApplyFilter = () => {
  //   onApplyFilter({ tickettype, dateFrom, dateTo, urgency, status, createdBy });
  // };

 const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    console.log(message);
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const ticketTypeList = [
    { id: 1, name: "Issue", value: "issue" },
    { id: 2, name: "Feedback", value: "feedback" },
  ];
  const urgencyList = [
    { id: 1, name: "Yes", value: 1 },
    { id: 2, name: "No", value: 0 },
  ];

  const resetfilter = () => {
    setTicketType([]);
    setCreatedBy([]);
    setDateFrom(oneMonthAgoDate);
    setDateTo(todaysDate);
    setUrgency([]);
    setStatus([]);
    setticketdata(originalTicketData);
  };

  const handelnamechange = (e, value) => {
    setTicketType(value);
  };

  const handelstartdate = (e) => {
    setDateFrom(e.target.value);
  };

  const handeltodate = (e) => {
    setDateTo(e.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}route/getallactiveandinactiveuser`);
        if (response.ok) {
          const data = await response.json();

          setCreatedbylist(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allCreatedByList = [{first_name:"Select All"}, ...createdbylist]

  const handelcreatedby = (e, value) => {
    if(value.some((option)=>option.first_name==="Select All")) {
      setCreatedBy(createdbylist)
    }
    else {
  setCreatedBy(value);
    }
  
  };

  const handelurgencychange = (e, value) => {
    setUrgency(value);
  };

  const statuslist = [
    { id: 0, name: "Created", value: "created" },
    {
      id: 1,
      name: "Resolving",
      value: "resolving",
    },
    { id: 2, name: "Completed", value: "completed" },
  ];

  const handelstatuschange = (e, value) => {
    setStatus(value);
  };

  const handleApplyFilter = async (event) => {
    // Handle form submission logic here
    setLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      created_from_date: dateFrom || null,
      created_to_date: dateTo || null,
      type_of_ticket: tickettype.map((i) => i.value),
      ticket_priority: urgency.map((i) => i.value),
      status: status?.map((i) => i.value),
      created_by: createdBy.map((i) => i.id),
      user_id: parseInt(userId),
    };

    try {
      const response = await fetch(`${API_ENDPOINT}route/filterticket`, {
        method: "POST",
        headers,
        body: JSON.stringify(requestData),
      });

       const result = await response.json();
      if (response.ok) {
   
        setticketdata(result);
        setLoading(false);
      } else if (response.status === 400) {
          showSnackbar(result.message,'error')
      } else if (response.status === 401) {
        showSnackbar(result.message,'error')
      } else if (response.status === 403) {
             showSnackbar(result.message,'error')
      } 
       else {
           showSnackbar("Internal Server Error" ,'error')
      }
    } catch (error) {
     showSnackbar("Error fetching data:", 'error');
    }
  };

  return (
    <>
    <Collapse in={open} sx={{ marginTop: "5px" }}>
      <MainCard>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Typography variant="h6">Type Of Ticket</Typography>
            <CustomAutocompleteComp
              fullWidth
              value={tickettype}
              onChange={handelnamechange}
              multiple
              options={ticketTypeList}
              getOptionLabel={(option) => option.name}
              tooltipContent={(option) => option.name}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Typography variant="h6">Urgency</Typography>
            <CustomAutocompleteComp
              fullWidth
              value={urgency}
              onChange={handelurgencychange}
              multiple
              options={urgencyList}
              getOptionLabel={(option) => option.name}
              tooltipContent={(option) => option.name}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Typography variant="h6">Status</Typography>

            <CustomAutocompleteComp
              fullWidth
              value={status}
              onChange={handelstatuschange}
              multiple
              options={statuslist}
              getOptionLabel={(option) => option.name}
              tooltipContent={(option) => option.name}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Typography variant="h6">Created By</Typography>
            <CustomAutocompleteComp
              fullWidth
              value={createdBy}
              onChange={handelcreatedby}
              multiple
              options={allCreatedByList}
              getOptionLabel={(option) =>
                `${option.first_name ? option.first_name : ""} ${
                  option.last_name ? option.last_name : ""
                }`
              }
              tooltipContent={(option) =>
                `${option.first_name ? option.first_name : ""} ${
                  option.last_name ? option.last_name : ""
                }`
              }
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Typography variant="h6">Created Date From</Typography>
            <CustomTextFieldComp
              size="normal"
              type="date"
              fullWidth
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
              InputProps={{
                style: { borderRadius: "10px" },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Typography variant="h6">Created Date To</Typography>
            <CustomTextFieldComp
              size="normal"
              type="date"
              fullWidth
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
              InputProps={{
                style: { borderRadius: "10px" },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Typography variant="h6" sx={{ visibility: "hidden" }}>
              button
            </Typography>
            <Grid container gap={2}>
              <ApplyFilterButton onClick={handleApplyFilter} />
              <ResetFilterButton onClick={resetfilter} />
            </Grid>
          </Grid>
        </Grid>
      </MainCard>
    </Collapse>
         <CustomSnackbar

            open={snackbarOpen}
            onClose={() => setSnackbarOpen(false)}
            message={snackbarMessage}
            severity={snackbarSeverity}
          />
          </>
  );
}
